import { Component } from "@angular/core";

@Component({
  selector: "app-booking-progress-dialog",
  templateUrl: "./booking-progress-dialog.component.html",
  styleUrls: ["./booking-progress-dialog.component.css"]
})
export class BookingProgressDialogComponent {
  constructor() {}
}
